(function () {
  const pad = n => String(n).padStart(2, '0');
  const money = (cents, cur) => new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);

  function nextCutoff(day, hour) {
    const now = new Date(), t = new Date(now);
    t.setHours(hour, 0, 0, 0);
    t.setDate(now.getDate() + ((day - now.getDay() + 7) % 7));
    if (t <= now) t.setDate(t.getDate() + 7);
    return t;
  }

  function initProduct(root) {
    const variants = JSON.parse(root.querySelector('[data-ntc-variants]').textContent);
    const cur = root.dataset.currency;
    const idInput = root.querySelector('input[name="id"]');
    const planInput = root.querySelector('[data-ntc-plan]');
    const qty = root.querySelector('input[name="quantity"]');
    const btn = root.querySelector('[data-ntc-add]');
    const main = root.querySelector('[data-ntc-main]');
    const set = (sel, txt) => root.querySelectorAll(sel).forEach(e => (e.textContent = txt));

    root.querySelectorAll('[data-ntc-thumb]').forEach(b => b.addEventListener('click', () => {
      main.src = b.dataset.src;
      main.removeAttribute('srcset');
      root.querySelectorAll('[data-ntc-thumb]').forEach(x => x.classList.toggle('is-active', x === b));
    }));

    function update() {
      const picked = root.querySelector('input[name="ntc-variant"]:checked');
      const v = variants.find(x => String(x.id) === (picked ? picked.value : idInput.value)) || variants[0];
      const sub = !!root.querySelector('input[name="ntc-freq"][value="sub"]:checked');
      const q = Math.max(1, parseInt(qty.value, 10) || 1);
      idInput.value = v.id;
      if (planInput) planInput.disabled = !sub;
      set('[data-ntc-size-label]', v.title);
      set('[data-ntc-price-once]', money(v.price * q, cur));
      if (v.sub != null) set('[data-ntc-price-sub]', money(v.sub * q, cur));
      set('[data-ntc-freq-label]', sub ? root.dataset.subLabel : root.dataset.onceLabel);
      const unit = sub && v.sub != null ? v.sub : v.price;
      btn.disabled = !v.available;
      btn.textContent = v.available ? `${root.dataset.addLabel} · ${money(unit * q, cur)}` : root.dataset.soldLabel;
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }

    root.addEventListener('change', update);
    root.querySelectorAll('[data-ntc-qty]').forEach(b => b.addEventListener('click', () => {
      qty.value = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.ntcQty)));
      update();
    }));
    update();
  }

  function tick() {
    document.querySelectorAll('[data-ntc-cutoff]').forEach(el => {
      const diff = Math.max(0, nextCutoff(+el.dataset.day, +el.dataset.hour) - new Date());
      const u = { d: Math.floor(diff / 864e5), h: Math.floor(diff / 36e5) % 24, m: Math.floor(diff / 6e4) % 60, s: Math.floor(diff / 1e3) % 60 };
      el.querySelectorAll('[data-u]').forEach(x => (x.textContent = pad(u[x.dataset.u])));
      if (el.hasAttribute('data-ntc-chip')) {
        el.textContent = `Ships from the island ${u.d >= 6 ? 'next' : 'this'} ${el.dataset.dayName} · ${u.d}d ${u.h}h left`;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-ntc-product]').forEach(initProduct);
    tick(); setInterval(tick, 1000);
  });
})();
/* NTC: Add to basket without leaving the page (updates cart icon + drawer) */ (function(){document.addEventListener('submit',async function(e){var form=e.target;if(!form||!form.closest||!form.closest('[data-ntc-product]'))return;if((form.getAttribute('action')||'').indexOf('/cart/add')<0)return;e.preventDefault();var btn=form.querySelector('[data-ntc-add]');var label=btn?btn.textContent:'';if(btn)btn.disabled=true;var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';var sent=false;try{var CLU=(await import('@shopify/events')).CartLinesUpdateEvent;var fd=new FormData(form);var ids=Array.prototype.map.call(document.querySelectorAll('cart-items-component'),function(c){return c.dataset.sectionId}).filter(Boolean);if(ids.length)fd.append('sections',ids.join(','));var qty=Number(fd.get('quantity'))||1;var d=CLU.createPromise();form.dispatchEvent(new CLU({action:'add',context:'product',lines:[{merchandiseId:fd.get('id'),quantity:qty}],promise:d.promise}));sent=true;var res=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});var data=await res.json();var cart=await (await fetch(root+'cart.js')).json();d.resolve({cart:CLU.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'ntc-product',itemCount:qty,sections:data.sections,didError:!res.ok}});if(!res.ok)throw new Error(data.description||data.message||'Could not add');if(btn)btn.textContent='Added ✓'}catch(err){if(!sent){form.submit();return}if(btn)btn.textContent=(err&&err.message)||'Something went wrong'}setTimeout(function(){if(btn){btn.textContent=label;btn.disabled=false}},2000)})})();